import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_4 = { class: "w-5" }

import { PropType } from "vue";

import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";

import UiProgress from "@/components/ui/UiProgress.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsPostVotingVariant',
  props: {
  maxValue: { type: Number, default: 0 },
  voted: Boolean,
  selected: Boolean,
  showResult: Boolean,
  // eslint-disable-next-line no-undef
  variant: { type: Object as PropType<PostVotingVariant>, required: true },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiCell, {
    active: __props.selected || __props.variant.selected
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.variant.text), 1),
        (__props.showResult)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.variant.count) + " чел. ", 1))
          : _createCommentVNode("", true)
      ]),
      (__props.showResult)
        ? (_openBlock(), _createBlock(UiProgress, {
            key: 0,
            value: __props.variant.count,
            max: __props.maxValue,
            class: "mt-2"
          }, null, 8, ["value", "max"]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (__props.voted)
      ? {
          name: "right",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (__props.variant.selected)
                ? (_openBlock(), _createBlock(UiIcon, {
                    key: 0,
                    type: "solid",
                    icon: "CheckCircle",
                    class: "text-blue-500"
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["active"]))
}
}

})